import React from "react";
import { scrollToApply } from "../utils/scroll";
import { secondaryButtonClass } from "../utils/buttonStyles";
import { track } from "../utils/tracking";
export const LOGO_URL = "https://studiowebvip.com/wp-content/uploads/logo-studioweb-2.png";
export function TopBar() {
  return <header className="sticky top-0 z-40 border-b border-line bg-ink/85 backdrop-blur-md" data-id="element-363" data-mp="1t4za521aj22k">
      <div className="page-container flex h-16 items-center justify-between gap-4" data-id="element-364" data-mp="2qs81vervx7d0">
        <img src={LOGO_URL} alt="Studio Web VIP" className="h-9 w-auto shrink-0 object-contain" data-id="element-365" data-mp="2quaorpxqqkdi" />
        <button type="button" onClick={() => {
        track("CTAClick", {
          source: "topbar"
        }, {
          custom: true
        });
        scrollToApply();
      }} className={`${secondaryButtonClass} min-h-[48px] px-4 text-[13px] uppercase tracking-[0.02em]`} data-id="element-366" data-mp="2lvr37qn27alo">
          AGENDAR DIAGNÓSTICO
        </button>
      </div>
    </header>;
}